export class DatalayerEvent {
}
